var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cartContainer',{attrs:{"ptInitData":_vm.ptInitData,"doChkCartAddTxt":_vm.doChkCartAddTxt,"isLp":_vm.isLp,"teikiKounyuu":0},on:{"pt125doOrder":_vm.pt125doOrder}})}
var staticRenderFns = []

export { render, staticRenderFns }